module.exports = __webpack_public_path__ + "media/images/costumes/top/wasou/thumbnail-3-3e616debef8301e1e147ab5e1824593c.jpg";